import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BotonToggleComponent } from "./boton-toggle/boton-toggle.component";
import { MaterialModule } from "../material/material.module";

@NgModule({
    imports: [
        CommonModule,
        MaterialModule
    ],
    declarations: [
        BotonToggleComponent
    ],
    providers: [
    ],
    entryComponents: [
    ],
    exports: [
        BotonToggleComponent
    ]
})
export class BotonToggleModule { }